import React from 'react';
import CONFIG from '../../../config';
import './ButtonStyles.scss'
import { getNavigationPageLink } from '../../../utils';
import { useSelector } from 'react-redux';
import { IProductsState } from '../../../types/store/reducer';

interface IButtonProps {
  content: string;
  handleClick: () => void;
}

interface Products {
  products : IProductsState
}

const DiscoverButton = ({ content,  handleClick }: IButtonProps) => {
  let countryCode = useSelector(({ products } : Products) => products.countryCode);
  return (
    <a
      className="btn"
      onClick={() => {
        handleClick();
        if (CONFIG.isUPC) {
          window.location.href = getNavigationPageLink(countryCode, 'rewards');
        } else {
          let win = window.open(getNavigationPageLink(countryCode, 'rewards'), '_blank');
          win.focus();
        }
      }}
    >
      <div className="cta cta_secondary discover-button" data-alt-text={content}>
        <span>{content}</span>
      </div>
    </a>
  );
};

export default DiscoverButton